<template>
	<div class="socket" style="display: none;" v-if="device=='pc'">
		<vxe-modal :width="width" :height="height" v-model="boxShow" size="mini" :lock-scroll="false" :lock-view="false"
			:destroy-on-close="true" :mask="false" :position="position" @hide="boxClose" transfer>
			<template #default>
				<matter :istab="false" :showTag="false" :fontSize="12" />
				<!-- 				<el-link style="font-size: 12px;margin-bottom: 4px;" v-for="(item,index) in data" :key="index" :underline="true" @click="open(item)">{{item.title}}</el-link>
			-->
			</template>
		</vxe-modal>
	</div>
</template>
<script>
	import matter from '@_system/views/main/cooperate/matter/index.vue'

	export default {
		// props: {
		// 	id: {
		// 		type: [Number, String],
		// 		default: () => {
		// 			return 0
		// 		}
		// 	}
		// },
		data() {
			return {
				ws: window.config.socket,
				ping: 0,
				pong: 0,
				pingTimer: 0,
				boxShow: false,
				width: 300,
				height: 200,
				position: {
					top: 0,
					left: 0
				},
				data: [],
				device: window.systemMethods.device()
			}

		},
		sockets: {
			// 连接成功
			onopen() {
				//console.log("socket success")
				this.sendObj('LOGIN', {
					project: window.config.project,
					logincompany: window.config.project
				})
				this.$store.commit('system/setOnline', true)
				this.pingTimer = setInterval(() => {
					if (this.ping === this.pong) {
						this.ping += 1;
						this.sendObj('PING', this.ping)
					} else {
						this.reconnectPing()
					}
				}, 50000)
			},
			// 接收消息
			onmessage(e) {
				//console.log("commit")
				this.pong = this.ping
				this.$store.commit('system/setSocketMessage', JSON.parse(e.data))
				// if (event === "PONG") {
				// 	this.onPong(data);
				// }
			},
			// 连接报错
			onerror() {},
			// 关闭连接
			onclose() {
				console.log("socket close")
				this.$store.commit('system/setOnline', false)
				this.$store.commit('system/setOnlineList', {})
				clearInterval(this.pingTimer)
			},
		},
		watch: {
			socketTimestamp() {
				let message = this.$store.state.system.websocketMessage
				//console.log(message)
				if (message.event == 'NOTICE' && message.data.data) {
					this.$notify({
						title: '通知',
						message: message.data.data,
						type: message.data.type,
						duration: message.data.duration,
						dangerouslyUseHTMLString: message.data.dangerouslyUseHTMLString,
					})
				}
				if (message.event == 'FLOW') {
					setTimeout(()=>{
						this.boxShow = true
						setTimeout(()=>{
							this.boxShow = false
						},5000)
					},1000)
				}
				if (message.event == 'LOGIN') {
					window.onlineList = message.data
					//this.$store.commit('system/setOnlineList', message.data)
				}
			}
		},
		computed: {
			socketTimestamp() {
				return this.$store.state.system.socketTimestamp
			}
		},
		created() {

		},
		mounted() {
			this.position.top = document.documentElement.clientHeight - this.height - 10
			this.position.left = document.documentElement.clientWidth - this.width - 10
			this.initWebSocket()
		},
		methods: {
			initWebSocket() {
				this.$connect(this.ws)
				// setTimeout(() => {
				// 	this.$socket.sendObj({
				// 		demo: 1
				// 	})
				// }, 1000)

			},
			reconnectPing() {
				console.log("断线")
			},
			sendObj(event, data) {
				this.$socket.sendObj({
					event: event,
					token: window.localStorage.getItem(this.$store.state.token),
					data: data
				})
			},
			boxClose() {
				this.data = []
			}
		},
		components: {
			matter
		}
	}
</script>
